import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REFERRAL_CODE_KEY = "referralCode";

export const useReferralCode = () => {
  const location = useLocation();

  useEffect(() => {
    // check if the referral code is already in the session storage
    const urlParams = new URLSearchParams(location.search);
    const referralCode = urlParams.get("referralCode");

    if (referralCode) {
      sessionStorage.setItem(REFERRAL_CODE_KEY, referralCode);
    }
  }, [location.search]);

  const getReferralCode = () => {
    return sessionStorage.getItem(REFERRAL_CODE_KEY);
  };

  const clearReferralCode = () => {
    sessionStorage.removeItem(REFERRAL_CODE_KEY);
  };

  return {
    getReferralCode,
    clearReferralCode,
  };
};

export default useReferralCode;
